var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logout",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.45,
    height: 12.409,
    viewBox: "0 0 12.45 12.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_139",
    "data-name": "Trazado 139",
    d: "M6.2,12.224H1.551a.517.517,0,0,1-.517-.517V2.4a.517.517,0,0,1,.517-.517H6.2A.517.517,0,0,0,6.2.85H1.551A1.553,1.553,0,0,0,0,2.4v9.306a1.553,1.553,0,0,0,1.551,1.551H6.2a.517.517,0,0,0,0-1.034Z",
    transform: "translate(0 -0.85)",
    fill: "#ccd0d0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(4.136 2.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_140",
    "data-name": "Trazado 140",
    d: "M178.26,110.416l-3.143-3.1a.517.517,0,1,0-.726.736l2.246,2.217h-6.02a.517.517,0,0,0,0,1.034h6.02l-2.246,2.217a.517.517,0,1,0,.726.736l3.143-3.1a.517.517,0,0,0,0-.736Z",
    transform: "translate(-170.1 -107.165)",
    fill: "#ccd0d0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e6e9946782f5855aa92265bc5f20b516.svg";
export { ForwardRef as ReactComponent };